import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import CaretUpSVG from '../../../assets/icons/app/caret-up.svg?raw';

export const CaretUpIcon = (props) => <CustomSVG svg={CaretUpSVG} preserveColors appIconSmall {...props} />;
